<template>
  <div class="editor scroll-vertical">
    <detail-item
      name="Path"
      imgName="circle">
      {{ file.path }}
    </detail-item>
    <detail-item
      name="File Size"
      imgName="circle">
      {{ file.size | bytesToSize }}
    </detail-item>
    <detail-item
      name="User"
      imgName="circle">
      {{ relatedUser(file.uid) }}
    </detail-item>
    <detail-item
      name="Group"
      imgName="circle">
      {{ relatedGroup(file.gid) }}
    </detail-item>
    <detail-item
      v-if="file.downloadedFrom"
      name="Download From"
      imgName="circle">
      {{ file.downloadedFrom }}
    </detail-item>
    <detail-item
      name="File Accessed Time"
      imgName="circle">
      {{ file.accessed | formatEpochDate(gmt) }}
    </detail-item>
    <detail-item
      name="File Changed Time"
      imgName="circle">
      {{ file.changed | formatEpochDate(gmt) }}
    </detail-item>
    <detail-item
      name="File Created Time"
      imgName="circle">
      {{ file.created | formatEpochDate(gmt) }}
    </detail-item>
    <detail-item
      name="File Modified Time"
      imgName="circle">
      {{ file.modified | formatEpochDate(gmt) }}
    </detail-item>
    <detail-item
      name="Hash"
      imgName="circle">
      sha1: {{ file.sha1hex }}<br>
      sha256: {{ file.sha256hex }}
    </detail-item>
    <alert-log-signing-info
      :signingInfo="file.signingInfo"
      :related="related">
    </alert-log-signing-info>
    <detail-item
      v-if="file.xattrs && file.xattrs.length > 0"
      name="XAttrs"
      imgName="circle">
      <div class="vertical">
        <div v-for="attr in file.xattrs" :key="attr" class="attr">{{ attr }}</div>
      </div>
    </detail-item>
  </div>
</template>

<script>
import alertlog from '@/mixins/alertlog';
import gmt from '@/mixins/gmt';
import DetailItem from '@/components/DetailItem.vue';
import AlertLogSigningInfo from '@/components/alertlogs/AlertLogSigningInfo.vue';

export default {
  name: 'AlertLogFile',
  mixins: [alertlog, gmt],
  components: {
    DetailItem,
    AlertLogSigningInfo,
  },
  props: {
    file: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.vertical {
  display: flex;
  flex-direction: column;
}

.attr {
  width: 100%;
}
</style>
